import React, { RefObject, useLayoutEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import cls from 'classnames';
import './index.module.scss';

interface CommonLayoutHeaderProps {
  height?: number;
  fixHeader?: boolean; // 在vertical的情况下，是否 fix header, true: content自然布局，由父级组件出滚动条， false： content 占据header剩余的高度，由content组件出滚动条
  children: React.ReactNode;
  className?: string;
}

interface CommonLayoutProps {
  children: React.ReactNode | React.ReactNodeArray;
  className?: string;
}

interface CommonLayoutContentProps {
  children: React.ReactNode;
  className?: string;
  forwardedRef?: RefObject<HTMLDivElement>;
}

export function CommonLayoutHeader(props: CommonLayoutHeaderProps) {
  const { height, fixHeader, children, className } = props;
  const headerRef = useRef<HTMLDivElement>();

  useLayoutEffect(() => {
    // eslint-disable-next-line react/no-find-dom-node
    const headerDOM = ReactDOM.findDOMNode(headerRef.current);
    const parentDOM = headerDOM?.parentNode;
    if (fixHeader) {
      parentDOM?.classList.add('fix-header');
    }
  }, [fixHeader]);

  return (
    <div
      /* eslint-disable-next-line no-return-assign */
      ref={(ref: HTMLDivElement) => (headerRef.current = ref)}
      className={cls('common-layout-header', className, {
        'fix-header': fixHeader
      })}
      style={{
        height: height ? `${height}px` : '',
        flex: `0 0 ${height}px`
      }}
    >
      {children}
    </div>
  );
}

export function CommonLayoutContent(props: CommonLayoutContentProps) {
  const { children, className, forwardedRef } = props;
  return (
    <div id="common-layout-content-id" className={cls('common-layout-content', className)} ref={forwardedRef}>
      {children}
    </div>
  );
}

function CommonLayout(props: CommonLayoutProps) {
  const { children, className } = props;
  return <div className={cls('common-layout', className)}>{children}</div>;
}

export default CommonLayout;
